<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>
    <!-- Top Banner Section Start -->
    <div class="flex-grow">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/search-doctors-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">Search Doctors</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <!-- Search Section Start -->
        <div class="container mx-auto p-3 md:mb-5 xl:mb-[100px]">
            <div class="custom-margin">
                <h2>Selected Hospital : <span class="text-[#112c76e8]">{{selectedHospitalName}}</span></h2>
            </div>
            <div
                class="md:custom-margin relative border border-solid border-slate-200 bg-white/95 text-black mx-auto p-2 rounded  shadow-md w-full">
                <form [formGroup]="searchForm"(ngSubmit)="search()">
                    <div class="flex flex-wrap space-x-2 mb-6 mt-6 text-blavk">
                        <!-- Branch Selection -->
                        <div class="flex-1">
                            <mat-form-field class="w-full">
                                <mat-label>Branch</mat-label>
                                <mat-select formControlName="branches" (selectionChange)="onBranchSelectionChange($event.value)">
                                    <mat-option *ngFor="let branch of allBranches"
                                        value="{{branch.id}}">{{branch.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Department Selection -->
                        <div class="flex-1">
                            <mat-form-field class="w-full">
                                <mat-label>Department</mat-label>
                                <mat-select formControlName="specialities" (selectionChange)="onSpecialitySelectionChange($event.value)">
                                    <mat-option *ngFor="let speciality of allSpecialities"
                                        value="{{speciality.id}}">{{speciality.title}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Search Box -->
                        <div class="flex-1">
                            <!-- <mat-form-field class="w-full">
                                <mat-label>Doctor Name</mat-label>
                                <input type="text" matInput placeholder="" formControlName="doctorName" [(ngModel)]="doctorName">
                            </mat-form-field> -->
                            <mat-form-field class="example-full-width w-full">
                                <mat-label>Doctor Name</mat-label>
                                <input type="text" matInput formControlName="doctorName" [matAutocomplete]="auto" [(ngModel)]="doctorName">
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDoctorFn"(optionSelected)="onDoctorSelection($event)">
                                    <mat-option *ngFor="let doctor of filteredDoctors | async" [value]="doctor">
                                        {{ doctor.title }}
                                      </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                        </div>
                        <!-- <div class="flex-1 md:text-center">
                            <button type="submit"
                                class="w-full md:w-1/2 xl:w-full md:mx-auto px-36 md:px-15 sm:px-15 book-now rounded-full borderfont-bold uppercase text-xs py-3 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2">
                                Search</button>
                        </div> -->
                    </div>
                </form>
            </div>
        </div>
        <!-- Search Section End -->

        <!-- Doctor List Section Start -->
        <div class="container mx-auto p-10 md:mb-5 xl:mb-0">
            <!-- Mat Spinner  -->
            <ngx-spinner bdColor="rgba(256, 256, 256, 0.5)" size="default" color="#6eabc6" type="ball-spin-fade"
                [fullScreen]="true">
                <p style="color: black"> Fetching doctors... </p>
            </ngx-spinner>
            <div class="doctors-sec md:custom-margin" *ngIf="doctors && doctors.length > 0">
                <div class="mt-10 flex flex-wrap justify-center">
                    <div class="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 px-4 mb-8"
                        *ngFor="let doctor of doctors;">
                        <div class="w-full rounded-[30px] overflow-hidden shadow-lg mx-1" id="doctor-profile-card">
                            <div class="doctor-img-wrapper">
                                <div class="doctor-img">
                                    <img class="w-full h-[450px] sm:h-[400px] rounded-[30px] object-cover object-top"
                                            [src]="doctor.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor.image : '/assets/images/icons/doctor-default-img.png'" alt="{{doctor.title}}">
                                </div>
                            </div>
                            <div class="pt-[22px] doctor-details-content">
                                <div class="px-6 doctor-details-inner">
                                    <div class="inline-block text-[12px] leading-[28px] uppercase pl-[15px] relative tracking-2 doctor-position">{{doctor.specialty}}</div>
                                    <h3 class="text-[20px] leading-[24px] mt-2 text-[#010d27] doctor-title">{{doctor.title}}</h3>
                                </div>
                                <div class="px-6 pb-2">
                                    <button (click)="bookNow(doctor)"
                                        class="book-now w-full rounded-md borderfont-bold uppercase text-xs px-4 py-3 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2 cursor-pointer">
                                        View Doctor Details</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-10 custom-border flex justify-center items-center" *ngIf="doctors && doctors.length === 0">
                <div class="flex justify-center">
                    <p class="text-[#667ac3] text-center">
                        "Sorry, but we couldn't find any doctors specializing in this field at the moment. Please
                        consider broadening your search criteria or checking back later.<br> If you have any specific
                        questions or need assistance, feel free to contact our support team. We're here to help!"
                    </p>
                </div>
            </div>
        </div>
        <!-- Doctor List Section End -->
    </div>

    <!-- Footer  -->
    <app-message></app-message>
    <app-footer></app-footer>
</div>